module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00042.20857177.jpg";